import { render } from "./PageGenerator.vue?vue&type=template&id=9eef95b4"
import script from "./PageGenerator.vue?vue&type=script&lang=js"
export * from "./PageGenerator.vue?vue&type=script&lang=js"

import "./PageGenerator.vue?vue&type=style&index=0&id=9eef95b4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__